export default "/images/94dfd5d296380cf74af6e2808bb2345d.avif";